import { render, staticRenderFns } from "./TechnicalFeaturesFramework.vue?vue&type=template&id=76972d61"
import script from "./TechnicalFeaturesFramework.vue?vue&type=script&lang=js"
export * from "./TechnicalFeaturesFramework.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports